<div class="title">
  <mat-icon>category</mat-icon>
  Product Classes
</div>
<div class="description">SELECT THE PRODUCT CLASSES TO FILTER BY</div>

<div class="options">
  @for (class of classes$ | async; track class) {
    <elements-filter-chip
      icon="category"
      [caption]="class.module.name + ' > ' + class.name"
      [selected]="isSelected(class)"
      (click)="isSelected(class) ? removeProduct(class) : addProduct(class)"
      [suffixIcon]="isSelected(class) ? 'close' : undefined"
      >
    </elements-filter-chip>
  }
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
